import { render, staticRenderFns } from "./OAuthRedirectUrlsList.vue?vue&type=template&id=6e042ea7"
import script from "./OAuthRedirectUrlsList.vue?vue&type=script&lang=js"
export * from "./OAuthRedirectUrlsList.vue?vue&type=script&lang=js"
import style0 from "./OAuthRedirectUrlsList.vue?vue&type=style&index=0&id=6e042ea7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports